import bg1 from '../../assets/background/background1.png';
import bg2 from '../../assets/background/background2.png';
import bg3 from '../../assets/background/background3.png';
import bg4 from '../../assets/background/background4.png';
import { sprites } from './assets.js';

export const PLATFORM_HEIGHT = 40;
export const LANDING_ZONE = 78;
export const START_SAFE_PLATFORMS = 7;
export const MOVING_PLATFORM_AMPLITUDE = 42;

export const POWER_UP_TYPES = {
  jumps: {
    id: 'jumps',
    label: '+saltos',
    color: '#39a8ff',
    glow: 'rgba(57, 168, 255, 0.62)',
    duration: 9,
    score: 80,
  },
  speed: {
    id: 'speed',
    label: 'turbo',
    color: '#ff4a4a',
    glow: 'rgba(255, 74, 74, 0.62)',
    duration: 7,
    boost: 132,
    score: 90,
  },
  invincible: {
    id: 'invincible',
    label: 'invencible',
    color: '#ffd84a',
    glow: 'rgba(255, 216, 74, 0.72)',
    duration: 8,
    score: 120,
  },
};

export const TUTORIAL_POWER_UPS = {
  8: { gap: 94, width: 340, lane: 2, prompt: 'Azul: más saltos', powerUp: 'jumps' },
  9: { gap: 108, width: 340, lane: 1, prompt: 'Rojo: corres más', powerUp: 'speed', peanuts: 1 },
  10: {
    gap: 112,
    width: 340,
    lane: 2,
    prompt: 'Amarillo: invencible',
    powerUp: 'invincible',
    enemy: 'ground',
  },
  11: { gap: 102, width: 340, lane: 1, prompt: 'Mira el contador arriba', peanuts: 2 },
};

export const levels = [
  {
    id: 'tutorial',
    name: 'Tutorial',
    detail: 'Aprende',
    tag: 'Inicio',
    speed: 188,
    gravity: 1740,
    jump: 710,
    enemyChance: 0,
    startGap: [58, 90],
    gap: [76, 118],
    startWidth: [280, 380],
    width: [230, 360],
    startVertical: 18,
    vertical: 42,
    lanes: [0.5, 0.61, 0.72],
    movingChance: 0,
    platformVariant: 0,
    backgroundSet: 'meadow',
    palette: ['#91d8ea', '#bcebc7', '#f5cb6b'],
    tutorial: true,
    background: bg1,
  },
  {
    id: 'meadow',
    name: 'Pradera',
    detail: 'Ritmo suave',
    tag: 'Fácil',
    speed: 210,
    gravity: 1780,
    jump: 700,
    enemyChance: 0.22,
    startGap: [70, 116],
    gap: [98, 160],
    startWidth: [260, 360],
    width: [175, 360],
    startVertical: 24,
    vertical: 58,
    lanes: [0.52, 0.62, 0.72],
    movingChance: 0.08,
    platformVariant: 0,
    backgroundSet: 'meadow',
    palette: ['#91d8ea', '#bcebc7', '#f5cb6b'],
    background: bg1,
  },
  {
    id: 'clover',
    name: 'Tréboles',
    detail: 'Saltos cómodos',
    tag: 'Fácil',
    speed: 218,
    gravity: 1810,
    jump: 705,
    enemyChance: 0.24,
    startGap: [74, 118],
    gap: [102, 164],
    startWidth: [250, 350],
    width: [170, 345],
    startVertical: 26,
    vertical: 60,
    lanes: [0.5, 0.61, 0.72],
    movingChance: 0.1,
    platformVariant: 1,
    backgroundSet: 'meadow',
    palette: ['#8fd2e5', '#aee9bd', '#f4d16f'],
    background: bg2,
  },
  {
    id: 'bridge',
    name: 'Puentes',
    detail: 'Más precisión',
    tag: 'Medio',
    speed: 226,
    gravity: 1850,
    jump: 715,
    enemyChance: 0.28,
    startGap: [76, 122],
    gap: [106, 172],
    startWidth: [235, 325],
    width: [150, 310],
    startVertical: 27,
    vertical: 64,
    lanes: [0.48, 0.6, 0.73],
    movingChance: 0.13,
    platformVariant: 2,
    backgroundSet: 'meadow',
    palette: ['#88cce1', '#9edba8', '#eec86a'],
    background: bg2,
  },
  {
    id: 'cookie',
    name: 'Galleta',
    detail: 'Ruta estable',
    tag: 'Medio',
    speed: 232,
    gravity: 1880,
    jump: 720,
    enemyChance: 0.32,
    startGap: [78, 126],
    gap: [108, 178],
    startWidth: [245, 340],
    width: [165, 335],
    startVertical: 28,
    vertical: 66,
    lanes: [0.48, 0.59, 0.72],
    movingChance: 0.14,
    platformVariant: 3,
    backgroundSet: 'barn',
    palette: ['#7bc6d8', '#edc486', '#d4733e'],
    background: bg3,
  },
  {
    id: 'straw',
    name: 'Paja',
    detail: 'Más enemigos',
    tag: 'Medio',
    speed: 240,
    gravity: 1930,
    jump: 730,
    enemyChance: 0.36,
    startGap: [82, 130],
    gap: [112, 186],
    startWidth: [240, 330],
    width: [160, 330],
    startVertical: 30,
    vertical: 70,
    lanes: [0.46, 0.58, 0.72],
    movingChance: 0.16,
    platformVariant: 4,
    backgroundSet: 'barn',
    palette: ['#78bfd6', '#e8bd78', '#d06b3d'],
    background: bg3,
  },
  {
    id: 'moon',
    name: 'Setas',
    detail: 'Saltos exigentes',
    tag: 'Difícil',
    speed: 250,
    gravity: 1980,
    jump: 745,
    enemyChance: 0.42,
    startGap: [84, 134],
    gap: [118, 195],
    startWidth: [225, 315],
    width: [145, 300],
    startVertical: 32,
    vertical: 74,
    lanes: [0.45, 0.57, 0.71],
    movingChance: 0.18,
    platformVariant: 5,
    backgroundSet: 'moon',
    palette: ['#6ea9c7', '#86c4a7', '#e7a947'],
    background: bg4,
  },
  {
    id: 'bramble',
    name: 'Zarzas',
    detail: 'Obstáculos densos',
    tag: 'Difícil',
    speed: 256,
    gravity: 2010,
    jump: 750,
    enemyChance: 0.45,
    startGap: [86, 136],
    gap: [120, 202],
    startWidth: [220, 306],
    width: [140, 294],
    startVertical: 34,
    vertical: 78,
    lanes: [0.44, 0.57, 0.71],
    movingChance: 0.2,
    platformVariant: 1,
    backgroundSet: 'bramble',
    obstacleKinds: ['bramble', 'thistle'],
    obstacleChance: 0.14,
    palette: ['#6fabc1', '#6aa768', '#d88e45'],
  },
  {
    id: 'crystal',
    name: 'Cristales',
    detail: 'Suelo helado',
    tag: 'Experto',
    speed: 264,
    gravity: 2050,
    jump: 760,
    enemyChance: 0.48,
    startGap: [88, 140],
    gap: [124, 210],
    startWidth: [214, 300],
    width: [138, 286],
    startVertical: 36,
    vertical: 82,
    lanes: [0.43, 0.56, 0.7],
    movingChance: 0.24,
    platformVariant: 3,
    backgroundSet: 'crystal',
    obstacleKinds: ['crystalSpike', 'thistle'],
    obstacleChance: 0.15,
    palette: ['#7dbfd6', '#9fd7cf', '#e4f6ff'],
  },
  {
    id: 'fence',
    name: 'Valla rota',
    detail: 'Carrera técnica',
    tag: 'Experto',
    speed: 272,
    gravity: 2080,
    jump: 768,
    enemyChance: 0.52,
    startGap: [90, 144],
    gap: [128, 218],
    startWidth: [210, 292],
    width: [134, 278],
    startVertical: 38,
    vertical: 86,
    lanes: [0.42, 0.55, 0.69],
    movingChance: 0.26,
    platformVariant: 4,
    backgroundSet: 'fence',
    obstacleKinds: ['fencePost', 'bramble'],
    obstacleChance: 0.16,
    palette: ['#78b5c9', '#d3a35d', '#f3c06b'],
  },
];

export const backgroundThemes = {
  meadow: {
    skyTop: '#7fd2ee',
    skyBottom: '#b7edc8',
    farHill: '#7ec98f',
    nearHill: '#4fa96f',
    ground: '#7ab565',
    props: [0, 1],
  },
  barn: {
    skyTop: '#78c6df',
    skyBottom: '#f0cc8c',
    farHill: '#d7b16b',
    nearHill: '#9bbb68',
    ground: '#c7924e',
    props: [0, 3],
  },
  moon: {
    skyTop: '#556fa7',
    skyBottom: '#77b6c9',
    farHill: '#668f8f',
    nearHill: '#5e9b75',
    ground: '#6d9a66',
    props: [4, 0],
  },
  bramble: {
    skyTop: '#6eaec6',
    skyBottom: '#bfe4bf',
    farHill: '#739b80',
    nearHill: '#496f4d',
    ground: '#4c6b3f',
    props: [1, 5],
  },
  crystal: {
    skyTop: '#7fc7e3',
    skyBottom: '#d9f7ff',
    farHill: '#9cced8',
    nearHill: '#78b5bd',
    ground: '#7bbfca',
    props: [4, 0],
  },
  fence: {
    skyTop: '#7fc0d7',
    skyBottom: '#f2d098',
    farHill: '#c89b5b',
    nearHill: '#9b7848',
    ground: '#9a673a',
    props: [3, 5],
  },
};

export const characters = [
  {
    id: 'hamster',
    name: 'Rojo',
    sprite: sprites.hamster,
    deathSprite: sprites.hamsterAngel,
    width: 62,
    height: 54,
  },
  {
    id: 'blueHamster',
    name: 'Azul',
    sprite: sprites.blueHamster,
    deathSprite: sprites.blueHamsterAngel,
    width: 62,
    height: 54,
  },
  {
    id: 'tasmanian',
    name: 'Turbo',
    sprite: sprites.tasmanian,
    deathSprite: sprites.tasmanianAngel,
    width: 66,
    height: 56,
  },
  {
    id: 'squirrel',
    name: 'Ardilla',
    sprite: sprites.squirrel,
    deathSprite: sprites.squirrelAngel,
    width: 62,
    height: 58,
  },
  {
    id: 'hedgehog',
    name: 'Erizo',
    sprite: sprites.hedgehog,
    deathSprite: sprites.hedgehogAngel,
    width: 64,
    height: 56,
  },
];
